import { Box, Container, Typography } from "@mui/material";
import ListCard from "./ListCard";
import SliderBanner from "./SliderBanner";

const box = {
    display: 'flex',
    overflow: 'hidden'
}

const container = {
    mt: 5,
    mb: 7,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}

export default function CardProduct() {
    return (
        <Box component="section" sx={box}>
            <Container sx={container}>
                <Typography variant="h4">Card Product</Typography>
                <SliderBanner />
                <ListCard />
            </Container>
        </Box>
    )
}